import { Loader } from '@/components/shared';
import { WizardLayout } from '../layout';
import { Suspense } from 'react';
import { Outlet } from 'react-router-dom';

interface IWizardProps {
  isLogged?: boolean;
}

export const Wizard: React.FC<IWizardProps> = (props): JSX.Element => {
  return (
    <WizardLayout {...props}>
      <Suspense fallback={<Loader />}>
        <Outlet />
      </Suspense>
    </WizardLayout>
  );
};
